import { APIClient } from '@frontend/api-utils';

const endpoint = '/bpost-api/v1';

export class BpostShippingLabelClient extends APIClient {
    public static async previewShippingLabelHTML(accountId: string, barcodeId: string): Promise<string> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/barcodes/${barcodeId}/preview-shipping-label-html`);
        return await this.handleTextResponse(response);
    }
    public static async previewShippingLabelPDF(accountId: string, barcodeId: string): Promise<ArrayBuffer> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/barcodes/${barcodeId}/preview-shipping-label-pdf`);
        return await this.handleArrayBufferResponse(response);
    }
    public static async printShippingLabel(accountId: string, barcodeId: string, iotId: string): Promise<void> {
        const response = await this.post(`${endpoint}/accounts/${accountId}/barcodes/${barcodeId}/print-shipping-label`, { iot_id: iotId });
        return await this.handleVoidResponse(response);
    }
}
